/**
 * @generated SignedSource<<c4755904903b8b2e28fcc7caef4dfe37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DocsExportModalStreamHasMeetingRecordingsQuery$variables = {
  streamId: string;
};
export type DocsExportModalStreamHasMeetingRecordingsQuery$data = {
  readonly noteStream: {
    readonly notes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly meetingRecordings: ReadonlyArray<{
            readonly id: string;
          }> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};
export type DocsExportModalStreamHasMeetingRecordingsQuery = {
  response: DocsExportModalStreamHasMeetingRecordingsQuery$data;
  variables: DocsExportModalStreamHasMeetingRecordingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingRecording",
  "kind": "LinkedField",
  "name": "meetingRecordings",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DocsExportModalStreamHasMeetingRecordingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotesConnection",
            "kind": "LinkedField",
            "name": "notes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DocsExportModalStreamHasMeetingRecordingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotesConnection",
            "kind": "LinkedField",
            "name": "notes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e8753a862b94cafc0df2b7a723e46155",
    "id": null,
    "metadata": {},
    "name": "DocsExportModalStreamHasMeetingRecordingsQuery",
    "operationKind": "query",
    "text": "query DocsExportModalStreamHasMeetingRecordingsQuery(\n  $streamId: ID!\n) {\n  noteStream(id: $streamId) {\n    notes {\n      edges {\n        node {\n          meetingRecordings {\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "450c9bc31c66a3830591ab2bfeb2403b";

export default node;
